import React from 'react';
import {connect} from 'react-redux';

import _ from 'topmeteo/utils/i18n';

import {changeFAIEnabled} from 'topmeteo/flight-planning/actionCreators';

import CheckboxGroup from './CheckboxGroup';

const Label = _('Enable FAI Sectors');

const FAICheckbox = ({checked, onChange}) => (
    <CheckboxGroup
        id="fai-toggle-checkbox"
        label={Label}
        checked={checked}
        onChange={onChange}
    />
);

const mapStateToProps = ({FAIEnabled}) => ({checked: FAIEnabled});

const mapDispatchToProps = dispatch => ({
    onChange: ({target}) => dispatch(changeFAIEnabled(target.checked)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FAICheckbox);
